<template>
  <div>
    <!-- 通信录信息 -->
    <el-form  :rules="rules" class="demo-ruleForm" :model="abData" ref="abData" label-width="100px">
      <el-row>
        <el-col :span="8">
          <el-form-item label="姓名" prop="name" id="name">
            <el-input size="mini" v-model="abData.name" :maxlength="25" placeholder="请输入内容" class="DataWidth">
            </el-input>
          </el-form-item>
        </el-col>

        <el-col :span="8">
          <el-form-item label="移动电话" prop="mobile">
            <el-input size="mini" v-model="abData.mobile" :maxlength="25" placeholder="请输入内容" class="DataWidth" @input="check('mobile')">
            </el-input>
          </el-form-item>
        </el-col>

        <el-col :span="8">
          <el-form-item label="座机" prop="tel">
            <el-input size="mini" v-model="abData.tel" :maxlength="25" placeholder="请输入内容" class="DataWidth" id="tel" @input="check('tel')">
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="8">
          <el-form-item label="邮箱" prop="email" id="email">
            <el-input size="mini" v-model="abData.email" :maxlength="25" placeholder="请输入内容" class="DataWidth" @input="check('email')">
            </el-input>
          </el-form-item>
        </el-col>

        <el-col :span="8">
          <el-form-item label="是否共享" prop="isPrive">
            <el-select size="mini" v-model="abData.isPrive" id="isPrive" style="width: 100%;">
              <!-- //multiple> -->
              <el-option v-for="item in options_isPrive" :key="item.value" :label="item.name" :value="item.value"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="24">
          <el-form-item label="备注" prop="remark">
            <el-input size="mini" type="textarea" v-model="abData.remark" placeholder="请输入内容" class="DataWidth" :rows="2">
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <!-- 功能按钮 -->
    <span slot="footer" class="dialog-footer">
      <el-row style="margin-top:15px">
        <el-col :span="20">&nbsp;</el-col>
        <el-col :span="2">
          <el-button size="mini" type icon @click="reset(1);">关闭</el-button>
        </el-col>
        <el-col :span="2">
          <el-button size="mini" type="primary" icon="save" @click="save">保存</el-button>
        </el-col>
      </el-row>
    </span>
  </div>
</template>



<script>
export default {
  data() {
    const isMobile = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入移动电话'));
      } else {
        var reg = /^[1][3,4,5,7,8][0-9]{9}$/;
        if (!reg.test(value)) {
          callback(new Error('号码格式不正确'))
        }else{
          callback()
        }
      }
    };
    return {
      options_isPrive: [
        { name: "我的", value: "1" },
        { name: "共享", value: "0" }
      ],
      position: "right",
      //返回数据
      returnData: {},
      algin: 'right',
      rules: {
        name: [
          {required: true, message: '请输入姓名', trigger: 'blur'}
        ],
        mobile: [
          {required: true,validator: isMobile,trigger: 'blur'}
        ],
        isPrive: [
          {required: true, message: '请选择是否私用', trigger: 'blur'}
        ]
      }
    };
  },
  props: ["abData", "isNew"],

  //检查变量时用

  mounted: function() {
    // this.options_sex = this.CommonUtil.getCodeList("sex");
    // this.options_status = this.CommonUtil.getCodeList("status");
    // this.roleIdsTemp = this.abData.roleId;
  },
  methods: {
    check: function(name) {
      if (name == "mobile") {
        let mobile = this.abData.mobile;
        this.abData.mobile = mobile.replace(/[^0-9|^-]/g, "");
      } else if (name == "tel") {
        let tel = this.abData.tel;
        this.abData.tel = tel.replace(/[^0-9|^-]/g, "");
      } else if (name == "email") {
        //暂时只判断是否包含@
        let email = this.abData.email;
        let num = 0;
        let index = email.indexOf("@");
        while (index != -1) {
          num++; // 每出现一次 次数加一
          index = email.indexOf("@", index + 1); // 从字符串出现的位置的下一位置开始继续查找
        }
        if (num <= 0) {
          email = email + "@";
        } else if (num >= 2) {
          email = email
            .split("")
            .reverse()
            .join("");
          for (let i = 0; i < num - 1; i++) {
            email = email.replace("@", "");
          }
          email = email
            .split("")
            .reverse()
            .join("");
        }
        //去除中文等特殊符号
        this.abData.email = email.replace(/[^\w|^\-|^.|^@]/g, "");
      }
    },
    reset: function(model) {
      let temp = {};
      for (let x of Object.keys(this.returnData)) {
        temp[x] = this.returnData[x];
      }
      this.$refs["abData"].resetFields();
      if (model == 1) {
        this.$emit("closeAffressBook", null);
      } else {
        this.$emit("closeAffressBook", temp);
      }
    },
    // 保存
    save: function() {
      //校验
      // if (!this.abData["name"]) {
      //   this.$message({
      //     message: "请输入姓名",
      //     type: "warning"
      //   });
      //   return;
      // }
      // if (!this.abData["mobile"]) {
      //   this.$message({
      //     message: "请输入移动电话",
      //     type: "warning"
      //   });
      //   return;
      // }
      // if (!this.abData["isPrive"]) {
      //   this.$message({
      //     message: "请选择是否私用",
      //     type: "warning"
      //   });
      //   return;
      // }
      this.$refs["abData"].validate(valid => {
        if (valid) {
      if (this.abData["id"]) {
        this.$axios.post("/address/update", this.abData).then(res => {
          this.returnData = res.data;
          if (res.code == "0000") {
            this.$message({
              message: res.message,
              type: "success"
            });
            this.reset(2);
          } else {
            this.$message({
              message: res.message,
              type: "warning"
            });
          }
        });
      } else {
        this.$axios.post("/address/save", this.abData).then(res => {
          this.returnData = res.data;
          if (res.code == "0000") {
            this.$message({
              message: res.message,
              type: "success"
            });
            this.reset(2);
          } else {
            this.$message({
              message: res.message,
              type: "warning"
            });
          }
        });
      }
        }
      });
    }
  }
};
</script>


<style scoped>
div {
  margin-top: 0px;
}

.c {
  margin-top: 10px;
}

input[type=textarea]::-webkit-scrollbar {
  width: 6px;
  height: 6px;
  background: transparent;
}

input[type=textarea]::-webkit-scrollbar-thumb {
  background: transparent;
  border-radius: 4px;
}

input[type=textarea]:hover::-webkit-scrollbar-thumb {
  background: hsla(0, 0%, 53%, 0.4);
}

input[type=textarea]:hover::-webkit-scrollbar-track {
  background: hsla(0, 0%, 53%, 0.1);
}
</style>



// WEBPACK FOOTER //
// src/components/addressBook/thePopUpWindow.vue